<script>
import { ref, onMounted } from "vue";

export default {
  name: "CosmicBackground",
  setup() {
    const shootingStars = ref([]);
    const staticStars = ref([]);

    onMounted(() => {
      // 1. 유성우 (Shooting Stars) - 10개
      const shootingCount = 10;
      const tempShooting = [];

      for (let i = 0; i < shootingCount; i++) {
        const duration = Math.random() * 4 + 3; 
        
        tempShooting.push({
          id: i,
          style: {
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 40 + 100}%`,
            animationDuration: `${duration}s`,
            animationDelay: `-${Math.random() * 20}s`,
            opacity: Math.random() * 0.5 + 0.5,
            transform: `scale(${Math.random() * 0.5 + 0.7})` 
          },
        });
      }
      shootingStars.value = tempShooting;

      // 2. 배경 별 (Static Stars) - 50개
      const staticCount = 50;
      const tempStatic = [];
      
      for (let i = 0; i < staticCount; i++) {
        const size = Math.random() * 2 + 2; 
        
        tempStatic.push({
          id: `s_${i}`,
          style: {
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            width: `${size}px`,
            height: `${size}px`,
            animationDuration: `${Math.random() * 3 + 1}s`, 
            animationDelay: `${Math.random() * 5}s`,
            opacity: Math.random() * 0.7 + 0.3
          }
        });
      }
      staticStars.value = tempStatic;
    });

    return { shootingStars, staticStars };
  },
};
</script>

<template>
  <div class="cosmic-wrapper">
    
    <div class="nebula-glow"></div>

    <div class="static-star-container">
      <div 
        v-for="star in staticStars" 
        :key="star.id" 
        class="static-star" 
        :style="star.style"
      ></div>
    </div>

    <div class="shooting-star-container">
      <div
        v-for="star in shootingStars"
        :key="star.id"
        class="shooting-star"
        :style="star.style"
      ></div>
    </div>

    <div class="planets-layer">
      <div class="planet-obj p1" style="background-image: url('/images/planet1.png')"></div>
      <div class="planet-obj p4" style="background-image: url('/images/planet4.png')"></div>
      <div class="planet-obj p5" style="background-image: url('/images/planet5.png')"></div>
      <div class="planet-obj p3" style="background-image: url('/images/planet3.png')"></div>
      <div class="planet-obj p2" style="background-image: url('/images/planet2.png')"></div>
      <div class="planet-obj p6" style="background-image: url('/images/planet6.png')"></div>
    </div>
  </div>
</template>

<style scoped>
/* 배경 설정 */
.cosmic-wrapper {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100vh;
  z-index: -50;
  pointer-events: none;
  overflow: hidden;
  background-color: #050510;
  will-change: transform;
}

/* ⭐️ [핵심 복구] 네뷸라: 10px 확대 방식 (렉 없음) */
.nebula-glow {
  position: absolute;
  top: 50%; left: 50%;
  /* 1. 아주 작은 크기로 설정 */
  width: 10px; height: 10px;
  border-radius: 50%;
  
  /* 2. 밝기 조절: 0.4(너무 밝음) -> 0.15(은은함)로 수정 */
  background: radial-gradient(
    circle, 
    rgba(120, 50, 255, 0.15) 0%,   /* 0.15 ~ 0.2 추천 */
    rgba(0, 0, 0, 0) 70%
  );

  /* 3. 150배 뻥튀기 (GPU 가속) */
  transform: translate(-50%, -50%) scale(150);
  
  z-index: -20; 
  /* will-change는 굳이 안 써도 scale은 빠르지만, 확실히 하기 위해 추가 */
  will-change: transform; 
}

/* 배경 별 */
.static-star-container {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  z-index: 0;
}
.static-star {
  position: absolute;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.9);
  animation: twinkle linear infinite;
}
@keyframes twinkle {
  0% { opacity: 0.3; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1.3); } 
  100% { opacity: 0.3; transform: scale(0.8); }
}

/* 유성우 컨테이너 */
.shooting-star-container {
  position: absolute;
  top: 50%; left: 50%;
  width: 150vmax; height: 150vmax;
  transform: translate(-50%, -50%) rotate(-45deg); 
  z-index: 1;
}

/* 유성 스타일 */
.shooting-star {
  position: absolute;
  width: 300px; 
  height: 2px;
  background: linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
  border-radius: 999px;
  box-shadow: -4px 0 15px rgba(255, 255, 255, 1); 
  
  animation-name: shoot;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes shoot {
  0% { transform: translateX(0); opacity: 0; }
  5% { opacity: 1; }
  70% { opacity: 1; }
  100% { transform: translateX(-200vmax); opacity: 0; }
}

/* 행성 레이어 */
.planets-layer { 
  position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 2; 
}
.planet-obj {
  position: absolute; 
  background-size: contain; background-repeat: no-repeat; background-position: center;
  will-change: transform;
}

/* 행성 위치 */
.p1 { top: 5%; left: 5%; width: 150px; height: 150px; animation: float 12s infinite ease-in-out; }
.p4 { top: 15%; right: 10%; width: 90px; height: 90px; animation: float 9s infinite ease-in-out; }
.p5 { top: 40%; left: 10%; width: 70px; height: 70px; opacity: 0.8; animation: float 20s infinite ease-in-out; }
.p3 { top: 55%; right: 15%; width: 110px; height: 110px; opacity: 0.9; animation: float 18s infinite linear reverse; }
.p2 { top: 75%; right: 5%; width: 180px; height: 180px; animation: float 14s infinite ease-in-out alternate; }
.p6 { top: 85%; left: 15%; width: 60px; height: 60px; opacity: 0.7; animation: float 25s infinite ease-in-out; }

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
}

@media (max-width: 768px) {
  .planet-obj { transform: scale(0.7); }
  .p1 { left: -10%; } 
  .p2 { right: -10%; }
}
</style>